import axios from './config/config'
const defaultRoute = 'dashboard/'
export default{
    list:(type)=>{
        return axios.get(`${defaultRoute}`)
    }
} 